import { StatCard } from '@components/StatCard';
import { StatRow } from '@components/StatRow';
import { UtilityCard } from '@components/UtilityCard';
import { usePermissions } from '@hooks/usePermissions';
import { Grid, Typography } from '@mui/material';
import { utilityRegistry } from '@utilities/registry';

export const HomePage = () => {
  const { grantedUtilityIds } = usePermissions();
  const visibleUtilities = utilityRegistry.filter(utility => grantedUtilityIds.includes(utility.id));

  return (
    <>
      <StatRow>
        {/* TODO: These cards will be useful but we need to hook them up to real metrics that the API will expose */}
        <StatCard label="Utilities available to you" value={visibleUtilities.length} />
        {/* Temporarily commented out until we add batch tracking then these will be re-enabled */}
        {/* <StatCard label="Files processed, 7 days" value={128} />
        <StatCard accent="warning" label="Sync needs attention" value={1} /> */}
      </StatRow>

      <Typography sx={theme => ({ color: theme.palette.text.heading, fontSize: 16, fontWeight: 600, mb: 1.5 })}>
        Your Utilities
      </Typography>

      <Grid container spacing={2}>
        {visibleUtilities.map(utility => (
          <Grid key={utility.id} size={{ md: 4, sm: 6, xs: 12 }}>
            <UtilityCard
              // TODO: Need to actually hook these props to real data once the API is available
              metaText="Updated recently"
              statusLabel="Running"
              statusVariant="ok"
              utility={utility}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};
